// Counting on the web (2026-10-09). Lines go to her door (door.bymagpie.com) as "songbird",
// the same guest book every sister site writes to, so they show up in her daily reports.
// Nothing here is a person: one random word per browser so a visit reads as a path,
// no address, no cookie, never sent anywhere else. Off inside the desktop app.

const DOOR = 'https://door.bymagpie.com';
const ON = typeof window !== 'undefined' && !('__TAURI_INTERNALS__' in window) && /^https:/.test(window.location.protocol);

function visit(): string {
  try {
    let v = localStorage.getItem('songbird.visit');
    if (!v) {
      v = '';
      for (let i = 0; i < 8; i++) v += 'abcdefghijkmnpqrstuvwxyz23456789'.charAt(Math.floor(Math.random() * 32));
      localStorage.setItem('songbird.visit', v);
    }
    return v;
  } catch { return ''; }
}

const once = new Set<string>();

export function tell(what: string, detail?: string | number, onlyOnce = false) {
  if (!ON) return;
  if (onlyOnce) { if (once.has(what)) return; once.add(what); }
  const line = JSON.stringify({ site: 'songbird', what: what.slice(0, 24), detail: detail == null ? '' : String(detail).slice(0, 120), visit: visit() });
  try {
    if (what === 'left' && navigator.sendBeacon) { navigator.sendBeacon(DOOR + '/book', new Blob([line], { type: 'text/plain' })); return; }
    fetch(DOOR + '/book', { method: 'POST', keepalive: true, headers: { 'content-type': 'application/json' }, body: line }).catch(() => {});
  } catch { /* no door today */ }
}

function robot() { return !!navigator.webdriver || /bot|crawl|spider|slurp|preview|headless|facebookexternalhit|embedly|lighthouse/i.test(navigator.userAgent || ''); }

export function arrive() {
  if (!ON) return;
  tell(robot() ? 'robot' : 'arrived', /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'phone' : 'computer');
  // where they came from: ?from=TAG from her links, else only the sending site's name
  const m = /[?&]from=([A-Za-z0-9_-]{1,40})/.exec(window.location.search);
  if (m) {
    tell('came', m[1].toLowerCase());
    const rest = window.location.search.replace(/([?&])from=[^&]*&?/, '$1').replace(/[?&]$/, '');
    window.history.replaceState(null, '', window.location.pathname + rest + window.location.hash);
  } else {
    let h = '';
    try { h = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch { h = ''; }
    if (h && h !== window.location.hostname) tell('came', 'site ' + h);
  }
  const cameAt = Date.now();
  window.addEventListener('pagehide', () => tell('left', Math.round((Date.now() - cameAt) / 1000) + 's'));
}
